import { store } from 'v3/data/store';
import { TokenFormatEnum } from 'v3/shared/constants/token-type.enum';
import { tokenSlice } from './index';

export const setTokenCode = (code: string) => {
  store.dispatch(tokenSlice.actions.setToken(code));
};

export const setSelectedOption = (selectedOption: TokenFormatEnum) => {
  store.dispatch(tokenSlice.actions.setSelectedOption(selectedOption));
};

export const setCanSendToken = (canSendToken: boolean) => {
  store.dispatch(tokenSlice.actions.setCanSendToken(canSendToken));
};

export const setEnablePreContractDownload = (flag: boolean) => {
  store.dispatch(tokenSlice.actions.setEnablePreContractDownload(flag));
};
